import { Sparkles } from 'lucide-react';

export default function AppLogo() {
    return (
        <>
            <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-primary shadow-md shadow-black/10">
                <Sparkles className="size-4 text-primary-foreground" />
            </div>
            <div className="ml-1 grid flex-1 text-left text-sm">
                <span className="mb-0.5 truncate leading-tight font-semibold">
                    LeftUnread
                </span>
            </div>
        </>
    );
}
